// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 5714) return "static/chunks/5714-6431a23c06c2ff52.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"7405":"c9f7b777","9642":"17d537d6"}[chunkId] || chunkId) + "." + {"295":"fc15b220408a2118","579":"4363917eab2b32f4","605":"499649ab8bc09c88","1175":"982ac26c1b817e52","2127":"dd77436181b22f6d","4426":"0cdba7c8654b9a59","7405":"e167438465bd1f0f","9257":"31636a9379bd19e4","9642":"4990cce0cc547865"}[chunkId] + ".js";
};